/* eslint-disable */

export default {
  methods: {
    normalizeCnpj(valor) {
      return String(valor || "")
        .trim()
        .replace(/[./-]/g, "")
        .toUpperCase();
    },
    normalizeCpf(valor) {
      return String(valor || "").replace(/\D/g, "");
    },
    normalizeCpfCnpj(valor) {
      const cnpj = this.normalizeCnpj(valor);

      if (/[A-Z]/.test(cnpj)) {
        return cnpj;
      }

      return this.normalizeCpf(valor);
    },
    hasCnpjAlfanumerico(valor) {
      return /[A-Za-z]/.test(String(valor || ""));
    },
    formatCnpjAlfanumerico(valor) {
      const cnpj = this.normalizeCnpj(valor)
        .replace(/[^A-Z0-9]/g, "")
        .slice(0, 14);

      if (cnpj.length <= 11 && !/[A-Z]/.test(cnpj)) {
        return this.formatCpfDigits(cnpj);
      }

      return [
        cnpj.slice(0, 2),
        cnpj.slice(2, 5),
        cnpj.slice(5, 8),
        cnpj.slice(8, 12),
        cnpj.slice(12, 14).replace(/\D/g, ""),
      ]
        .filter(Boolean)
        .join("")
        .replace(/^(.{2})(.+)/, "$1.$2")
        .replace(/^(.{2})\.(.{3})(.+)/, "$1.$2.$3")
        .replace(/^(.{2})\.(.{3})\.(.{3})(.+)/, "$1.$2.$3/$4")
        .replace(/^(.{2})\.(.{3})\.(.{3})\/(.{4})(.+)/, "$1.$2.$3/$4-$5");
    },
    formatCpfDigits(valor) {
      const cpf = this.normalizeCpf(valor).slice(0, 11);

      return cpf
        .replace(/^(\d{3})(\d)/, "$1.$2")
        .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
    },
    onCpfCnpjInput(event, target, field) {
      const value = this.formatCnpjAlfanumerico(event.target.value);
      target[field] = value;
      event.target.value = value;
    },
    isValidCnpj(valor) {
      const cnpj = this.normalizeCnpj(valor);

      if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(cnpj)) {
        return false;
      }

      const calcDigit = (base, weights) => {
        const sum = weights.reduce((total, weight, index) => {
          return total + (base.charCodeAt(index) - 48) * weight;
        }, 0);
        const rest = sum % 11;

        return rest < 2 ? 0 : 11 - rest;
      };

      const firstDigit = calcDigit(cnpj.slice(0, 12), [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
      const secondDigit = calcDigit(cnpj.slice(0, 12) + firstDigit, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

      return cnpj.slice(12) === `${firstDigit}${secondDigit}`;
    },
    validaCpfCnpj(valor) {
      const val = this.normalizeCpfCnpj(valor);
      if (val.length == 11 && !/[A-Z]/.test(val)) {
        var cpf = val.trim(); 

        cpf = cpf.replace(/\./g, '');
        cpf = cpf.replace('-', '');
        cpf = cpf.split('');

        var v1 = 0;
        var v2 = 0;
        var aux = false;

        for (var i = 1; cpf.length > i; i++) {
          if (cpf[i - 1] != cpf[i]) {
            aux = true;
          }
        }

        if (aux == false) {
          return false;
        }

        for (var i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
          v1 += cpf[i] * p;
        }

        v1 = ((v1 * 10) % 11);

        if (v1 == 10) {
          v1 = 0;
        }

        if (v1 != cpf[9]) {
          return false;
        }

        for (var i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
          v2 += cpf[i] * p;
        }

        v2 = ((v2 * 10) % 11);

        if (v2 == 10) {
          v2 = 0;
        }

        if (v2 != cpf[10]) {
          return false;
        } else {
          return true;
        }
      } else if (val.length == 14) {
        return this.isValidCnpj(val);
      } else {
        return false;
      }
    },
  }
};
